import ValueGeneratorInterface from "./ValueGeneratorInterface"
import RandomNumberGenerator from "../RandomNumberGenerator"
import ValueInterface from "../../Model/Value/ValueInterface"

export default class EquationValueGenerator implements ValueGeneratorInterface {
  constructor(
    private readonly randomNumberGenerator: RandomNumberGenerator,
    private readonly generators: ValueGeneratorInterface[],
  ) {}

  public supports(_: number, level: number): boolean {
    return level > 1
  }

  public generate(value: number, level: number): ValueInterface {
    return this.randomNumberGenerator
      .pick<ValueGeneratorInterface>(
        this.generators.filter((generator: ValueGeneratorInterface): boolean =>
          generator.supports(value, level),
        ),
      )
      .generate(value, level)
  }
}
